<template lang="pug">
v-flex.box-main-mis-seguros-desktop-formatter.border-radius-top
  v-layout(row style="justify-content: center; gap: 80px; height: inherit;")
    .box-main-menu-formatter
      v-layout(
        style="width: 23.5em;"
        column
      )
        v-flex
          v-layout.box-mis-seguros(column)
            v-flex.box-title-main-formatter
              span(style="color:#0855C4; font-size: 18px;text-transform: capitalize;")
                b Hola {{ usuario.titleName }},
            v-flex.box-text-main-formatter(style="line-height: normal;")
              span(style="color:#454A6C; font-size: 14px;") Estos son los datos de tu seguro
                b  {{ this.setProductName() }}
        v-flex
          v-flex(style="margin-top: 1em;margin-left: 0em;margin-right: auto;width: 22.5em;")
            v-layout(row :class="{ 'box-buttons-centered': flagOcultarProyeccion }")
              v-flex
                ButtonSelect(
                  @selectButton="methodView"
                  :textBottunProp="'Plan'"
                  :activar="flagPlan"
                  :main="'true'"
                  )
              v-flex
                ButtonSelect(
                  @selectButton="methodView"
                  :textBottunProp="'Hoy'"
                  :activar="flagHoy"
                  )
              v-flex(v-if="!flagOcultarProyeccion")
                ButtonSelect(
                  @selectButton="methodView"
                  :textBottunProp="'Proyección'"
                  :activar="flagProyeccion"
                  )
          v-flex(style="margin-top: 1em;margin-left: 0em;margin-right: auto;width: 22.5em;")
            v-layout.box-monto-asegurado-formatter(column align-center)
              v-flex
                span(style="font-family: 'Omnes Medium';color: #454A6C;font-size: 16px;") {{ flagIsVidacash ? 'Monto Protección Principal' : 'Monto Asegurado'}}
              v-flex(style="margin: 0.3em 0em")
                IconText(
                  :iconMoney="iconMoneyMontoAsegurado"
                  :textMoney="poliza.montoAsegurado"
                  :typeMoney="poliza.tipoMoneda"
                  )
              v-flex
                v-layout.box-card-periodo-cuota-formatter(row justify-center)
                  v-flex(xs4)
                    CardNumberText(
                      :textNumber="`${poliza.periodoDePago} ${poliza.periodoDePago > 1 ? 'años' : 'año'}`"
                      :description="'Periodo de pago'")
                  v-flex(xs4)
                    CardNumberText(
                      :textNumber="flagIsVidacash ? poliza.primaProgramada : poliza.montoCuota"
                      :description="'Cuota '+ poliza.frecuenciaPago")
                  v-flex(xs4)
                    CardNumberText(
                      @selectButton="methodView"
                      style="cursor: pointer;"
                      :class="coberturaMethod"
                      :textNumber="poliza.coberturasVida ? poliza.coberturasVida.length : 0"
                      :description="'Ver Coberturas'"
                      :cardBackgroundColor="'#EA0D90'"
                      :hoverButton="'true'"
                      )
          v-flex.box-detail-devolucion(v-if="flagIsVidacash || flagIsRumbo" style="width: 22.5em;")
              CardIconTextDoubleRow(
                :icon="iconDevolucion"
                :text="poliza.tipoMoneda + setFormatNumber(poliza.montoDevolucion)"
                :detail="Number(poliza.porcentajeDevolucion)*100"
                :textTooltip="'Dinero que voy a recibir al término de mi periodo de pago.'"
                :ocultarMonto="flagOcultarProyeccion"
              )
          v-flex
            v-layout.box-menu-mis-seguros(:class="{'box-small': flagIsVidacash || flagIsRumbo}" column style="margin-top: 1em;overflow-y: overlay;")
              v-flex.box-menu-formatter(@click="methodView('mis seguros')" :style=" flagDatosMisSeguros ? 'border: 1px solid #0855C4' : '' ")
                IconTextIcon(
                  :textProp="'Datos de mi seguro'"
                  :iconTextProp="iconMisDatos"
                  :iconTextPropHover="iconMisDatosWhite"
                  :iconFlagProp="iconlistFlag")
              v-flex.box-menu-formatter(
                v-if="puedeSolicitudes"
                @click="methodView('mis solicitudes')"
                :style=" flagMisSolicitudes ? 'border: 1px solid #0855C4' : '' " )
                IconTextIcon(
                  :textProp="'Mis solicitudes'"
                  :iconTextProp="iconMisSolicitudes"
                  :iconTextPropHover="iconMisSolicitudesWhite"
                  :iconFlagProp="iconlistFlag")
              v-flex.box-menu-formatter(v-if="poliza.oriProducto !== 'VIDA_CASH_PLUS'" @click="methodView('estado de cuenta')" :style=" flagEstadoCuenta ? 'border: 1px solid #0855C4' : '' ")
                IconTextIcon(
                  :textProp="'Mi estado de cuenta'"
                  :iconTextProp="iconMiEstadoCuenta"
                  :iconTextPropHover="iconMiEstadoCuentaWhite"
                  :iconFlagProp="iconlistFlag")
              v-flex.box-menu-formatter(v-if="documentosEndosoDisponibles.length > 0" @click="methodView('documentos de endoso')" :style=" flagDocumentosEndoso ? 'border: 1px solid #0855C4 !important' : '' ")
                IconTextIcon(
                  :textProp="'Documentos de endoso'"
                  :iconTextProp="iconComprobanteElectronico"
                  :iconTextPropHover="iconComprobanteElectronicoWhite"
                  :iconFlagProp="iconlistFlag")
              v-flex.box-menu-formatter(v-if="poliza.oriProducto !== 'VIDA_CASH_PLUS'" @click="methodView('comprobante')" :style=" flagComprobante ? 'border: 1px solid #0855C4' : '' " )
                IconTextIcon(
                  :textProp="'Comprobante electrónico'"
                  :iconTextProp="iconComprobanteElectronico"
                  :iconTextPropHover="iconComprobanteElectronicoWhite"
                  :iconFlagProp="iconlistFlag")
              v-flex.box-menu-formatter(v-if="(poliza.oriProducto || '').toLowerCase() !== 'endosos'" @click="methodView('beneficiarios')" :style=" flagBeneficiarios ? 'border: 1px solid #0855C4' : '' " )
                IconTextIcon(
                  :textProp="'Mis beneficiarios'"
                  :iconTextProp="iconMisBeneficiarios"
                  :iconTextPropHover="iconMisBeneficiariosWhite"
                  :iconFlagProp="iconlistFlag")
              v-flex.box-menu-formatter(v-if="poliza.nombreAgente" @click="methodView('mi agente')" :style=" flagMiAgente ? 'border: 1px solid #0855C4' : '' " )
                IconTextIcon(
                  :textProp="'Mi asesor'"
                  :iconTextProp="iconMiAgente"
                  :iconTextPropHover="iconMiAgenteWhite"
                  :iconFlagProp="iconlistFlag")
              v-flex.box-menu-formatter(v-if="!poliza.nombreAgente" @click="methodView('mis canales')" :style=" flagMisCanales ? 'border: 1px solid #0855C4' : '' " )
                IconTextIcon(
                  :textProp="'Mis canales de atención'"
                  :iconTextProp="iconMisCanales"
                  :iconTextPropHover="iconMisCanales"
                  :iconFlagProp="iconlistFlag")
              v-flex.box-menu-formatter(
                v-if="!mayor5Anhos && !flagIsVidacash"
                @click="methodView('beneficios')"
                :style=" flagBeneficiosDesbloqueados ? 'border: 1px solid #0855C4' : '' "
                )
                IconTextIcon(
                  :textProp="'Beneficios desbloqueados'"
                  :iconTextProp="iconBeneficios"
                  :iconTextPropHover="''"
                  :iconFlagProp="iconlistFlag")
              v-flex.box-menu-formatter(
                v-if="flagIsVidacash"
                @click="methodView('vales')"
                :style=" flagMisVales ? 'border: 1px solid #0855C4' : '' "
                )
                IconTextIcon(
                  :textProp="'Mis vales'"
                  :iconTextProp="iconBeneficios"
                  :iconTextPropHover="''"
                  :iconFlagProp="iconlistFlag")

    .box-main-menu-formatter
      v-layout(
        colum
        align-center
        style="margin-left: 0em;margin-right: auto;max-width: 35em;min-width: 26em;width:26.5em;"
        )
        v-flex.detalle-main-menu(v-if="flagCoberturas")
          CoberturasDesktop(
            :coberturas="poliza.coberturasVida"
            :tipoMoneda="poliza.tipoMoneda"
            :taggeo="taggeo"
            )
        v-flex.detalle-mis-seguros.detalle-main-menu(v-if="flagDatosMisSeguros")
          DatosMisSegurosDesktop(
            @datosMisSegurosMethod="getPDFElectronicPolicy()"
            :numeroPoliza="poliza.numeroPoliza"
            :inicioFinVigencia="poliza.fechaVigencia+ ' - '+poliza.fechaFinVigencia"
            :periodoDePago="poliza.periodoDePago + ' '+ (poliza.periodoDePago>1 ? 'años' : 'año')"
            :periodoDeCobertura="poliza.periodoDeCobertura + ' '+ (poliza.periodoDeCobertura>1 ? 'años' : 'año')"
            :montoAsegurado="flagIsVidacash ? setFormatNumber(poliza.montoDevolucion) : poliza.montoAsegurado"
            :cuota="(poliza.primaProgramadaMoneda=='NUEVO SOL' ? 'S/' : '$')+''+(flagIsVidacash ? poliza.primaProgramada : poliza.montoCuota)"
            :frecuenciaDePago="poliza.frecuenciaPago"
            :pagoHasta="poliza.pagadoHasta"
            :tipoMoneda="poliza.tipoMoneda"
            :taggeo="taggeo"
            :producto="poliza.nombreProducto"
            :oriProducto="poliza.oriProducto || ''"
            :hasDocument="!!poliza.codigoProceso && (poliza.codigoProceso || []).length > 0"
          )
        v-flex.detalle-mis-solicitudes.detalle-main-menu.hoy(
          v-if="flagMisSolicitudes"
          )
          MisSolicitudes(
            :mas2Anhos="mas2Anhos"
            :puedeEndosar="poliza.puedeEndosar"
            :puedeCuotaComodin="poliza.puedeCuotaComodin"
            :puedeCambiarFrecuencia="poliza.puedeCambiarFrecuencia"
            :puedeLiberarEndoso="poliza.puedeLiberarEndoso"
            :puedeCambiarBeneficiario="poliza.puedeCambiarBeneficiario"
            :puedeRetirarCoberturas="poliza.puedeRetirarCoberturas"
            :poliza="poliza"
            :taggeo="taggeo"
            :solicitudBeneficiarios="solicitudBeneficiarios"
            :solicitudComodin="solicitudComodin"
            :solicitudEndosoEntidadFinanciera="solicitudEndosoEntidadFinanciera"
            :solicitudLiberacionEndoso="solicitudLiberacionEndoso"
            :solicitudAnulacion="solicitudAnulacion"
            :solicitudSeguimiento="solicitudSeguimiento"
            :action="noActionSend ? null : action"
          )
        v-flex.detalle-main-menu(v-if="flagEstadoCuenta")
          EstadoDeCuentaDesktop(
            :ceProp="ce"
            :poliza="poliza"
            :taggeo="taggeo"
          )
        v-flex.detalle-main-menu(v-if="flagComprobante")
          ComprobanteElectronicoDesktop(
            :listaDeComprobantes="listComprobantesElectronicos"
            :iconDescarga="iconDescargaComprobante"
            :poliza="poliza"
            :taggeo="taggeo"
            )
        v-flex.detalle-main-menu(v-if="flagDocumentosEndoso")
          DocumentosEndoso(
            v-if="flagDocumentosEndoso"
            :taggeo="taggeo"
            :documentos="documentosEndosoDisponibles"
            :id="requerimientoId"
          )
        v-flex.detalle-main-menu.hoy(v-if="flagBeneficiarios")
          MisBeneficiariosDesktop(
            :beneficiariosPrincipales = "beneficiariosPrincipales"
            :puedeCambiarBeneficiario="poliza.puedeCambiarBeneficiario"
            :beneficiariosContingentes = "beneficiariosContingentes"
            :poliza="poliza"
            :taggeo="taggeo"
            )
        v-flex.detalle-main-menu(style="height:30em" v-if="flagMiAgente")
          MiAgenteDesktop(
            :nombre="poliza.nombreAgente"
            :correo="poliza.emailAgente"
            :celular="''"
            :taggeo="taggeo"
          )
        v-flex.detalle-main-menu(style="height:30em" v-if="flagMisCanales")
          MisCanales(
            :taggeo="taggeo"
          )
        v-flex.hoy.detalle-main-menu(v-if="flagHoyView1")
          HoyDesktop(
            :periodos="flagIsVidacash ? poliza.tablaDevoluciones : poliza.tablaValoresGarantizados"
            :tipoMoneda="poliza.tipoMoneda"
            :inicioVigencia="poliza.fechaVigencia"
            :finVigencia="poliza.fechaFinVigencia"
            :pagoHasta="poliza.pagadoHasta"
            :totalPagoEfectuado="totalPagosEfectuados"
            :taggeo="taggeo"
          )
        v-flex.hoy.detalle-main-menu(v-if="flagHoyView2")
          HoyDesktopHasta5Vue(
            :periodos="flagIsVidacash ? hoy : poliza.tablaValoresGarantizados"
            :periodoDePago="poliza.periodoDePago"
            :tipoMoneda="poliza.tipoMoneda"
            :inicioVigencia="poliza.fechaVigencia"
            :finVigencia="poliza.fechaFinVigencia"
            :pagoHasta="poliza.pagadoHasta"
            :montoAsegurado="flagIsVidacash ? poliza.montoDevolucion : poliza.montoAsegurado"
            :cuota="poliza.montoCuota"
            :netoAnual="calculoPagoAnual"
            :totalPagoEfectuado="totalPagosEfectuados"
            :producto="poliza.oriProducto"
            :taggeo="taggeo"
            :nombreProducto="poliza.nombreProducto"
            :suenio="(poliza.informacionExtra || {}).suenio"
            )
        v-flex.detalle-main-menu(v-if="flagProyeccion" style="padding: 1em .7em")
          ProyeccionDesktop(
            @closeAlertGoTo = "methodView('plan')"
            :producto="poliza.nombreProducto"
            :montoAsegurado = "flagIsVidacash ? setFormatNumber(poliza.montoDevolucion) : poliza.montoAsegurado"
            :periodos="(flagIsVidacash || flagIsRumbo) ? poliza.tablaDevoluciones : poliza.tablaValoresGarantizados"
            :tipoMoneda="poliza.tipoMoneda"
            :numeroPoliza="poliza.numeroPoliza"
            :taggeo="taggeo"
            :oriProducto="poliza.oriProducto || ''"
          )
        v-flex.desbloqueados.detalle-main-menu(v-if="flagBeneficiosDesbloqueados")
          BeneficiosDesbloqueados(
            :mas2Anhos="mas2Anhos"
            :poliza="poliza"
            :solicitudBeneficiarios="solicitudBeneficiarios"
            :solicitudComodin="solicitudComodin"
            :solicitudEndosoEntidadFinanciera="solicitudEndosoEntidadFinanciera"
            :solicitudLiberacionEndoso="solicitudLiberacionEndoso"
            :solicitudAnulacion="solicitudAnulacion"
            :solicitudSeguimiento="solicitudSeguimiento"
            :puedeEndosar="poliza.puedeEndosar"
            :puedeCuotaComodin="poliza.puedeCuotaComodin"
            :puedeCambiarFrecuencia="poliza.puedeCambiarFrecuencia"
            :puedeLiberarEndoso="poliza.puedeLiberarEndoso"
            :puedeCambiarBeneficiario="poliza.puedeCambiarBeneficiario"
          )
        v-flex.detalle-main-menu(v-if="flagMisVales")
          MisVales(
            :poliza="poliza"
            :taggeo="taggeo"
          )
  PopupAlertMessage(
    @closeAlertPopup="closeAlertMethod"
    :openPopup="popupAlert.openPopup"
    :image="popupAlert.image"
    :title="popupAlert.title"
    :message="popupAlert.message"
    :messageButton="popupAlert.messageButton"
    :buttonClose="popupAlert.buttonClose"
    :imgHeight="popupAlert.imgHeight"
    :imgWidth="popupAlert.imgWidth"
      )
  //- LOADER PROCESS
  v-dialog(v-model="loader.flag" persistent width="300")
    v-card(color="primary" dark="")
      v-card-text
        | {{loader.text}}
        v-progress-linear.mb-0(indeterminate="" color="white")

</template>

<script>
import MisVales from '@/components/mis-seguros/MisVales.vue'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import PopupAlertMessage from '../../components/PopupAlertMessage.vue'
import ButtonSelect from '../../components/generic/ButtonSelect.vue'
import CardIconTextDoubleRow from '../../components/generic/CardIconTextDoubleRow.vue'
import CardNumberText from '../../components/generic/CardNumberText.vue'
import IconText from '../../components/generic/IconText.vue'
import IconTextIcon from '../../components/generic/IconTextIcon.vue'
import BeneficiosDesbloqueados from '../../components/mis-seguros/BeneficiosDesbloqueados.vue'
import CoberturasDesktop from '../../components/mis-seguros/CoberturasDesktop.vue'
import ComprobanteElectronicoDesktop from '../../components/mis-seguros/ComprobanteElectronicoDesktop.vue'
import DatosMisSegurosDesktop from '../../components/mis-seguros/DatosMisSegurosDesktop.vue'
import DocumentosEndoso from '../../components/mis-seguros/DocumentosEndoso.vue'
import EstadoDeCuentaDesktop from '../../components/mis-seguros/EstadoDeCuentaDesktop.vue'
import HoyDesktop from '../../components/mis-seguros/HoyDesktop.vue'
import HoyDesktopHasta5Vue from '../../components/mis-seguros/HoyDesktopHasta5.vue'
import MiAgenteDesktop from '../../components/mis-seguros/MiAgenteDesktop.vue'
import MisBeneficiariosDesktop from '../../components/mis-seguros/MisBeneficiariosDesktop.vue'
import MisCanales from '../../components/mis-seguros/MisCanales.vue'
import MisSolicitudes from '../../components/mis-seguros/MisSolicitudes.vue'
import ProyeccionDesktop from '../../components/mis-seguros/ProyeccionDesktop.vue'
import electronicVouchers from '../../interfaces/electronicVouchers'
import Functionalities from '../../interfaces/functionalities'
import paymentFrequency from '../../interfaces/paymentFrequency'
import Transacts from '../../interfaces/transacts'

export default {
  props: [
    'infoPoliza',
    'infoUser',
    'action'
  ],
  data() {
    return {
      noActionSend: false,
      actionSent: false,
      iconMoneyMontoAsegurado: require('./../../assets/icons-mis-seguros/icon-money.svg'),
      iconDevolucion: require('./../../assets/icons-mis-seguros/icon-devolucion.svg'),
      iconlistFlag: require('./../../assets/icons-mis-seguros/icon-round-navigate-next.svg'),
      iconComprobanteElectronico: require('./../../assets/icons-mis-seguros/icon-comprobante-electrónico.svg'),
      iconComprobanteElectronicoWhite: require('./../../assets/icons-mis-seguros/icon-comprobante-electrónico-white.svg'),
      iconMisDatos: require('./../../assets/icons-mis-seguros/icon-datos-mi-seguro.svg'),
      iconMisDatosWhite: require('./../../assets/icons-mis-seguros/icon-datos-mi-seguro-white.svg'),
      iconMisSolicitudes: require('./../../assets/icons-mis-seguros/icon-mis-solicitudes.svg'),
      iconMisSolicitudesWhite: require('./../../assets/icons-mis-seguros/icon-mis-solicitudes-white.svg'),
      iconMiEstadoCuenta: require('./../../assets/icons-mis-seguros/icono-mi-estado-cuenta.svg'),
      iconMiEstadoCuentaWhite: require('./../../assets/icons-mis-seguros/icono-mi-estado-cuenta-white.svg'),
      iconMisBeneficiarios: require('./../../assets/icons-mis-seguros/icono-mis-beneficiarios.svg'),
      iconMisBeneficiariosWhite: require('./../../assets/icons-mis-seguros/icono-mis-beneficiarios-white.svg'),
      iconMiAgente: require('./../../assets/icons-mis-seguros/icono-mi-agente.svg'),
      iconMiAgenteWhite: require('./../../assets/icons-mis-seguros/icono-mi-agente-white.svg'),
      iconMisCanales: require('./../../assets/icons-mis-seguros/icono-mis-canales.svg'),
      iconDescargaComprobante: require('./../../assets/icons-mis-seguros/icon-flag-down.svg'),
      iconBeneficios: require('./../../assets/icons/icon-nuevo.svg'),
      iconAniversario: require('./../../assets/icons/gif-aniversario.gif'),
      totalPagosEfectuados: 0,
      flagPlan: true,
      flagHoy: false,
      flagHoyView1: false,
      flagHoyView2: false,
      flagProyeccion: false,
      flagProyeccionTaggeo: false,
      flagCoberturas: false,
      flagDatosMisSeguros: false,
      flagMisSolicitudes: false,
      flagDocumentosEndoso: false,
      documentosEndosoDisponibles: [],
      requerimientoId: null,
      flagEstadoCuenta: false,
      flagComprobante: false,
      flagBeneficiarios: false,
      flagMiAgente: false,
      flagMisCanales: false,
      flagBeneficiosDesbloqueados: false,
      flagMisVales: false,
      flagIsVidacash: false,
      flagIsRumbo: false,
      listaDeComprobantes: [],
      beneficiariosPrincipales: [],
      beneficiariosContingentes: [],
      poliza: {},
      usuario: {},
      listComrpobantesElectronicosActuales: [],
      listComprobantesElectronicos: [],
      items: [],
      selectedTypeDoc: null,
      ce: {
        maxDate: null,
        minDate: null,
        modalStart: false,
        modalEnd: false,
        startDate: null,
        endDate: null,
        textFieldStartDate: null,
        textFieldEndDate: null
      },
      loader: {
        flag: false,
        text: 'Cargando la página...'
      },
      popupAlert: {
        openPopup: false,
        image: require('@/assets/characters/informa.svg'),
        title: 'Estimado cliente',
        message: '',
        messageButton: 'Entendido',
        buttonClose: false,
        imgHeight: 150,
        imgWidth: 150
      },
      hoy: [
        {
          anho: '02',
          lock: false
        }, {
          anho: '03',
          lock: false
        }, {
          anho: '04',
          lock: false
        }, {
          anho: '05',
          lock: false
        }
      ],
      arrValoresGarantizadosMenos5: [],
      cuotaPeriodo: 0,
      numeroProyecciones: 0,
      taggeo: {
        tipoDocumento: '',
        numeroDocumento: '',
        numeroPoliza: '',
        ramo: '',
        producto: '',
        nombreProducto: '',
        nombre: 'Mis Seguros - ' + ((this.infoPoliza.nombreProducto || '').includes('VIDACASH') ? 'VC' : 'PG'),
        antiguedad: 0
      },
      mayor5Anhos: false,
      mas2Anhos: false,
      solicitudBeneficiarios: [],
      solicitudComodin: [],
      solicitudEndosoEntidadFinanciera: [],
      solicitudLiberacionEndoso: [],
      solicitudAnulacion: [],
      solicitudSeguimiento: [],
      calculoPagoAnual: 0,
      puedeSolicitudes: false
    }
  },
  methods: {
    ...mapActions('user', ['getBenefits', 'getComprobantes', 'getPDFPolizaElectronica']),
    ...mapActions('requirements', ['getAllRequirementsPerPolicy', 'filterPolicyRequirements']),
    ...mapActions('endorsements', ['getDocsEndorsement']),
    ...mapActions('event', ['eventLog']),
    setProductName() {
      if (this.flagIsRumbo) {
        return 'Rumbo'
      }
      return this.flagIsVidacash ? 'Vida con Devolución' : this.poliza.oriProducto
    },
    setFormatNumber(number) {
      return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(number)
    },
    methodView(item) {
      let self = this
      const nombreProducto = this.poliza.nombreProducto || this.poliza.producto
      if (item === 'comprobante' && !Functionalities.isAvailable(Functionalities.vida.COMPROBANTES, self.functionsRules, self, nombreProducto)) {
        return
      }
      if (this.actionSent) {
        this.noActionSend = true
      }

      this.flagHoy = item === 'hoy'
      this.flagPlan = (
        item === 'plan' ||
        item === 'mis seguros' ||
        item === 'mis solicitudes' ||
        item === 'estado de cuenta' ||
        item === 'comprobante' ||
        item === 'beneficiarios' ||
        item === 'mi agente' ||
        item === 'mis canales' ||
        item === 'beneficios' ||
        item === 'vales' ||
        item === 'documentos de endoso'
      )
      this.flagProyeccion = item === 'proyección'
      this.flagCoberturas = item === 'ver coberturas'
      this.flagDatosMisSeguros = (item === 'plan' || item === 'mis seguros')
      this.flagMisSolicitudes = item === 'mis solicitudes'
      this.flagDocumentosEndoso = item === 'documentos de endoso'
      this.flagEstadoCuenta = item === 'estado de cuenta'
      this.flagComprobante = item === 'comprobante'
      this.flagBeneficiarios = item === 'beneficiarios'
      this.flagMiAgente = item === 'mi agente'
      this.flagMisCanales = item === 'mis canales'
      this.flagBeneficiosDesbloqueados = item === 'beneficios'
      this.flagMisVales = item === 'vales'
      this.flagHoyView1 = false
      this.flagHoyView2 = false

      // //SOLICITUDE
      // if (flagOrigen.flag && flagOrigen.origen == 'solicitudes') {
      //   this.popupAlert.openPopup = true
      //   this.popupAlert.messageButton = "Entendido"
      //   this.popupAlert.message = "No hemos logrado obtener la información solicitada. Por favor, volver a intentarlo en unos minutos."
      // }
      // HOY
      if (this.flagHoy) {
        if (!this.flagIsVidacash) {
          if (!this.poliza.tablaValoresGarantizados || this.poliza.tablaValoresGarantizados.length <= 0) {
            this.popupAlert.image = require('@/assets/characters/informa.svg')
            this.popupAlert.title = 'Estimado cliente'
            this.popupAlert.openPopup = true
            this.popupAlert.message = 'No hemos encontrado la información'
            this.popupAlert.messageButton = 'Entendido'
            this.methodView('mis seguros')
          } else if (this.mayor5Anhos) {
            this.flagHoyView1 = true
          } else {
            this.flagHoyView2 = true
          }
        }
        if (this.poliza.oriProducto === 'VIDA CON DEVOLUCIÓN PLUS') {
          this.popupAlert.openPopup = true
          this.popupAlert.image = require('@/assets/characters/informa.svg')
          this.popupAlert.title = 'Estimado cliente'
          this.popupAlert.message = 'Por el momento no se encuentra activa esta funcionalidad.'
          this.popupAlert.messageButton = 'Entendido'
          this.popupAlert.buttonClose = false
          this.flagHoy = false
          this.flagHoyView1 = false
          this.flagHoyView2 = false
          return
        }
      }

      // PROYECCION - VALIDAR PAGO AL DIA
      if (this.flagProyeccion) {
        let today = new Date()

        let pagadoHasta = this.poliza.pagadoHasta.split(/[/-]/)
        let auxPagadoHasta = new Date(Number(pagadoHasta[2]), Number(pagadoHasta[1]) - 1, Number(pagadoHasta[0]))

        if (today > auxPagadoHasta) {
          this.popupAlert.openPopup = true
          this.popupAlert.image = require('@/assets/characters/informa.svg')
          this.popupAlert.title = 'Estimado cliente'
          this.popupAlert.message = 'Aún cuentas con cuotas pendientes de pago.'
          this.popupAlert.messageButton = 'Pago de cuotas'
          this.popupAlert.buttonClose = true

          this.eventLog({
            'tipoDocumento': self.taggeo.tipoDocumento,
            'numeroDocumento': self.taggeo.numeroDocumento,
            'categoria': 'Consulta',
            'nombre': self.taggeo.nombre,
            'datos': {
              'numero_de_Poliza': self.taggeo.numeroPoliza,
              'cuotas_Pendientes': 'SI',
              'antiguedad': self.periodoActual === undefined ? '01' : self.periodoActual.anho,
              'proyecciones': self.numeroProyecciones,
              'producto_Consultado': self.taggeo.ramo,
              'subproducto_Consultado': self.taggeo.nombreProducto,
              'navegacion': 'Proyección',
              'dispositivo': 'desktop'
            }
          })
        } else {
          this.flagProyeccionTaggeo = true
          this.numeroProyecciones = 0
        }
      } else if (this.flagProyeccionTaggeo) {
        this.flagProyeccionTaggeo = false

        this.eventLog({
          'tipoDocumento': self.taggeo.tipoDocumento,
          'numeroDocumento': self.taggeo.numeroDocumento,
          'categoria': 'Consulta',
          'nombre': self.taggeo.nombre,
          'datos': {
            'numero_de_Poliza': self.taggeo.numeroPoliza,
            'cuotas_Pendientes': 'NO',
            'antiguedad': self.periodoActual === undefined ? '01' : self.periodoActual.anho,
            'proyecciones': self.numeroProyecciones,
            'producto_Consultado': self.taggeo.ramo,
            'subproducto_Consultado': self.taggeo.nombreProducto,
            'navegacion': 'Proyección',
            'dispositivo': 'desktop'
          }
        })
      }

      if (this.flagComprobante && this.poliza.oriProducto !== 'VIDA_CASH_PLUS') {
        if (this.listComrpobantesElectronicosActuales.length > 0) {
          self.showComprobantesElectronicos()
        } else {
          self.popupAlert.openPopup = true
          self.popupAlert.title = 'Estimado cliente'
          self.popupAlert.message = 'En estos momentos, estamos trabajando en poner a disposición tu comprobante. Pero no te preocupes, en un plazo máximo de 5 días hábiles ya lo tendrás listo para la descarga.' // 'No hemos logrado obtener la información solicitada. Por favor, volver a intentarlo en unos minutos.'
          self.popupAlert.messageButton = 'Entendido'
          self.popupAlert.buttonClose = false
        }
      }
      this.loader.flag = false
    },
    periodoDePagoMethod(inicio, fin) {
      let inicioVigencia = inicio.split(/[/-]/)
      let finVigencia = fin.split(/[/-]/)

      let auxInicio = new Date(inicioVigencia[2], (inicioVigencia[1] - 1), inicioVigencia[0])
      let auxFin = new Date(finVigencia[2], (finVigencia[1] - 1), finVigencia[0])

      let periodoDePago = auxFin.getTime() - auxInicio.getTime()

      let aniosTotales = periodoDePago / (1000 * 3600 * 24 * 365)

      return Math.floor(aniosTotales)
    },
    formatMoneyMethod() {
      let tipoMoneda = (this.poliza.primaProgramadaMoneda === 'NUEVO SOL' ? 'S/' : '$')
      let montoAsegurado = parseFloat(this.poliza.montoCoberturaPrincipal).toLocaleString('en-US') // new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(this.poliza.montoCoberturaPrincipal)
      // let montoAsegurado = tipoMoneda.concat(this.poliza.montoCoberturaPrincipal)

      // let pagoEfectuados = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(this.poliza.totalPagosEfectuados)
      let montoCuota = parseFloat(this.flagIsVidacash ? this.poliza.primaProgramada : this.poliza.netoPago).toLocaleString('en-US') // new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(this.poliza.netoPago)
      this.poliza.montoAsegurado = montoAsegurado
      this.poliza.montoCuota = montoCuota
      this.poliza.tipoMoneda = tipoMoneda
      this.totalPagosEfectuados = parseFloat(this.poliza.totalPagosEfectuados).toLocaleString('en-US')
    },
    showComprobantesElectronicos() {
      let self = this
      const nombreProducto = this.poliza.nombreProducto || this.poliza.producto
      if (!Functionalities.isAvailable(Functionalities.vida.COMPROBANTES, self.functionsRules, self, nombreProducto)) {
        return
      }
      if (this.listComrpobantesElectronicosActuales.length < 1) {
        this.errorModalComprobantes = true
      }

      if (self.ce.startDate !== null && self.ce.endDate !== null) {
        this.loader.flag = true
        // LIMPIANDO LOS COMPROBANTES
        this.listComprobantesElectronicos = []
        let startDate = moment(self.ce.startDate + '-01')
        let endDate = moment(self.ce.endDate + '-01').endOf('month')

        // CONDICIONAL PARA CUBRIR TODOS LOS COMPROBANTES
        if (this.listComrpobantesElectronicosActuales.length > 0) {
          let documents = this.listComrpobantesElectronicosActuales
          // POBLANDO LOS COMPROBANTES
          for (let index = 0; index < documents.length; index++) {
            let fechaEmision = moment(documents[index].fechaEmision)
            if (fechaEmision.isBetween(startDate, endDate)) {
              let fechaEmisionFormat = moment(documents[index].fechaEmision, 'YYYY-MM-DD').locale('es').format('MMM-YYYY').replace('.', '')
              fechaEmisionFormat = fechaEmisionFormat.charAt(0).toUpperCase() + fechaEmisionFormat.slice(1)
              let hash = {
                fechaEmision: fechaEmisionFormat,
                tipoDocumento: documents[index].tipoComprobante,
                serie: documents[index].serie,
                correlativo: documents[index].numero,
                historico: false
              }
              this.listComprobantesElectronicos.push(hash)
            }
          }
        }
      } else {
        self.popupAlert.openPopup = true
        self.popupAlert.image = require('@/assets/characters/informa.svg')
        self.popupAlert.title = 'Estimado cliente'
        self.popupAlert.message = 'No podemos realizar la descarga. Intenta nuevamente en unos minutos o contáctate con Servicio de Atención al Cliente.'
        self.popupAlert.messageButton = 'Entendido'
        // self.$swal({
        //   title: 'Estimado cliente',
        //   text: 'Debe completar la información para buscar sus comprobantes electrónicos.',
        //   type: 'info',
        //   showCancelButton: false,
        //   confirmButtonColor: '#2177CC',
        //   confirmButtonText: 'Entendido'
        // })
      }
    },
    closeAlertMethod(item) {
      if (this.flagProyeccion && item) {
        this.$router.push('/pago-de-cuotas')
      } else if (this.flagHoy && item) {
        this.methodView('hoy')
      } else {
        this.methodView('plan')
      }
      this.popupAlert.openPopup = false
      this.loader.flag = false
    },
    async getPDFElectronicPolicy() {
      const self = this
      if (!Functionalities.isAvailable(Functionalities.vida.DESCARGA_POLIZA, self.functionsRules, self, self.poliza.producto)) {
        return
      }
      this.loader.flag = true
      this.loader.text = 'Descargando Póliza...'
      await this.getPdfPoliza({ numPoliza: this.poliza.numeroPoliza, makeDownload: true }, this.poliza.codigoProceso)
    },
    async getPdfPoliza(data, codigosProceso) {
      const self = this
      const metadata = []
      let downloaded = false
      for (let x = 0; x < codigosProceso.length && !downloaded; x++) {
        try {
          const res = await this.getPDFPolizaElectronica({ ...data, codProceso: codigosProceso[x] })
          if (res.status === 204) {
            this.loader.flag = false
            metadata.push({ status: res.status, codigo: codigosProceso[x] })
            if (x === codigosProceso.length - 1) {
              this.loader.flag = false
              self.popupAlert.openPopup = true
              self.popupAlert.image = require('@/assets/characters/informa.svg')
              self.popupAlert.title = 'Comunicado'
              self.popupAlert.message = 'Lamentamos las molestias, esta póliza aún no está disponible en formato electrónico. Estamos trabajando para ofrecerla lo antes posible.'
              self.popupAlert.messageButton = 'Entendido'
            }
          } else {
            this.loader.flag = false
            downloaded = true
          }
        } catch (error) {
          metadata.push({ error: error.response, codProceso: codigosProceso[x] })
          if (x === codigosProceso.length - 1) {
            this.loader.flag = false
            self.popupAlert.openPopup = true
            self.popupAlert.image = require('@/assets/characters/informa.svg')
            self.popupAlert.title = 'Comunicado'
            self.popupAlert.message = 'No podemos realizar la descarga. Inténtalo nuevamente en unos minutos o contáctate con Servicio de Atención al Cliente.'
            self.popupAlert.messageButton = 'Entendido'
          }
        }

        setTimeout(() => {
          self.$root.$emit('showNps', {
            nombre: 'NPS - Inicio de Encuesta',
            funcionalidad: 'Descarga de póliza',
            metadata: {
              error: metadata.length > 0 ? { response: metadata } : undefined,
              numeroPoliza: self.taggeo.numeroPoliza,
              productoConsultado: self.taggeo.ramo,
              subproductoConsultado: self.taggeo.nombreProducto
            }
          })
        }, 3000)
      }
    },
    getDiferenciaAnhos(date1, date2) {
      let diferencia = (date2.getTime() - date1.getTime()) / 1000 / (3600 * 24)
      return Math.abs(Math.round(diferencia / 365.25))
    },
    proyeccionesRealizadas(proyeccion) {
      this.numeroProyecciones += proyeccion
    },
    consultarDocumentosEndoso(numeroPoliza, flagCesionada) {
      const self = this
      const params = {
        numeroPoliza: numeroPoliza
      }
      
      self.getAllRequirementsPerPolicy(params).then(res => {
        if (res.data.success && res.data.data.length > 0) {
          self.documentosEndosoDisponibles = res.data.data.flatMap(req =>
            (req.req_files || []).map(file => ({
              ...file,
              state: req.state
            }))
          )
        } else {
          self.documentosEndosoDisponibles = []
        }
      }).catch(() => {
        self.documentosEndosoDisponibles = []
      })
    }
  },
  computed: {
    ...mapGetters('user', ['functionsRules']),
    coberturaMethod() {
      return this.flagCoberturas ? 'box-cobertura-select' : ''
    },
    flagOcultarProyeccion() {
      return true
    }
  },
  created() {
    if ((this.infoPoliza.nombreProducto || '').includes('VIDACASH')) {
      this.flagIsVidacash = true
    } else {
      this.flagIsVidacash = false
    }
    
    this.flagIsRumbo = (this.infoPoliza.oriProducto || '').toLowerCase() === Transacts.products.RUMBO
  },
  mounted() {
    let self = this
    // CARGANDO DATA
    this.loader.flag = true

    if (this.infoPoliza) {
      this.poliza = this.infoPoliza
      this.usuario = this.infoUser
      this.poliza.periodoDePago = this.periodoDePagoMethod(this.poliza.fechaVigencia, this.poliza.fechaFinVigencia)
      if (this.poliza.oriProducto === 'VIDA_CASH_PLUS' || this.poliza.oriProducto === 'VIDA CON DEVOLUCIÓN PLUS') {
        this.poliza.periodoDePago = this.poliza.periodoPago ? parseInt(this.poliza.periodoPago) : 0
        this.poliza.periodoDeCobertura = this.periodoDePagoMethod(this.poliza.fechaVigencia, this.poliza.fechaFinVigencia)
      }
      this.formatMoneyMethod()

      // lowerCase info usuario
      this.usuario.nombre = this.infoUser.nombre.toLowerCase()
      this.usuario.apPaterno = this.infoUser.apPaterno.toLowerCase()
      this.usuario.apMaterno = this.infoUser.apMaterno.toLowerCase()
      let auxNombre = this.usuario.nombre.split(' ')
      this.usuario.titleName = auxNombre[0]

      // lowerCase poliza
      this.poliza.frecuenciaPago = this.poliza.frecuenciaPago.toLowerCase()

      // lowerCase coberturas
      if (self.flagIsVidacash) {
        this.poliza.coberturasCash = this.infoPoliza.coberturasCash.map(data => {
          data.nombre = data.nombre.toLowerCase()
          data.nombre = data.nombre.charAt(0).toUpperCase() + data.nombre.slice(1)

          return data
        })
      } else {
        this.poliza.coberturasVida = this.infoPoliza.coberturasVida.map(data => {
          data.nombre = data.nombre.toLowerCase()
          data.nombre = data.nombre.charAt(0).toUpperCase() + data.nombre.slice(1)

          return data
        })
      }

      this.poliza.cliente = this.usuario
      sessionStorage.setItem('infoPoliza', JSON.stringify(this.poliza))
    } else {
      this.poliza = JSON.parse(sessionStorage.getItem('infoPoliza'))
      this.usuario = this.poliza.cliente
    }

    this.consultarDocumentosEndoso(this.poliza.numeroPoliza, this.poliza.flagCesionada || 'NO')

    // SETEANDO OBJ PARA TAGGEO
    this.taggeo.tipoDocumento = this.usuario.tipoDocumento
    this.taggeo.numeroDocumento = this.usuario.numeroDocumento
    this.taggeo.numeroPoliza = this.poliza.numeroPoliza
    this.taggeo.ramo = this.poliza.ramo
    this.taggeo.producto = this.poliza.producto
    this.taggeo.nombreProducto = this.poliza.nombreProducto

    this.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Plan',
        'dispositivo': 'desktop'
      }
    })

    // CALCULO PAGO ANUAL
    this.cuotaPeriodo = this.flagIsVidacash ? Number(this.poliza.primaProgramada) : Number(this.poliza.netoPago)

    switch (this.poliza.frecuenciaPago.toLowerCase()) {
      case paymentFrequency[0].periodo:
        this.calculoPagoAnual = this.cuotaPeriodo * paymentFrequency[0].pagos
        break
      case paymentFrequency[1].periodo:
        this.calculoPagoAnual = this.cuotaPeriodo * paymentFrequency[1].pagos
        break
      case paymentFrequency[2].periodo:
        this.calculoPagoAnual = this.cuotaPeriodo * paymentFrequency[2].pagos
        break
      case paymentFrequency[3].periodo:
        this.calculoPagoAnual = this.cuotaPeriodo * paymentFrequency[3].pagos
        break
      default:
        break
    }

    // FORMATEANDO DATOS
    let fecha = new Date()
    let fechaInicio = this.poliza.fechaVigencia.split(/[/-]/)

    if (!self.flagIsVidacash) {
      this.numeroPeriodo = Number(fecha.getFullYear()) - Number(fechaInicio[2])
      if (this.poliza.tablaValoresGarantizados && Array.isArray(this.poliza.tablaValoresGarantizados)) {
        this.periodoActual = this.poliza.tablaValoresGarantizados.filter(dato => self.numeroPeriodo + 1 === Number(dato.anho))[0]
      }
    }

    // MAYOR - MENOR A 5 AÑOS
    let inicioVigencia = this.poliza.fechaVigencia.split(/[/-]/)
    let hoy = new Date()
    let auxInicioVigencia = new Date(Number(inicioVigencia[2]), (Number(inicioVigencia[1]) - 1), Number(inicioVigencia[0]))
    this.mayor5Anhos = this.getDiferenciaAnhos(hoy, auxInicioVigencia) > 5

    // MAYOR A 2 AÑOS
    this.mas2Anhos = this.getDiferenciaAnhos(hoy, auxInicioVigencia) > 2

    // SELECCION OPCION MIS DATOS
    this.methodView('mis seguros')

    // ANIVESARIO
    let anniversarySince = new Date(hoy.getFullYear(), Number(inicioVigencia[1]) - 1, Number(inicioVigencia[0]))
    let anniversaryUntil = new Date(hoy.getFullYear(), Number(inicioVigencia[1]) - 1, Number(inicioVigencia[0]) + 10)

    let anniversaryFlag = localStorage.getItem('anniversaryPolicyZS' + self.poliza.numeroPoliza) === 'true'

    if (anniversarySince <= new Date() && anniversaryUntil >= new Date() && !anniversaryFlag && self.numeroPeriodo > 0) {
      self.popupAlert.openPopup = true
      self.popupAlert.buttonClose = true
      self.popupAlert.image = self.iconAniversario
      self.popupAlert.title = '¡Feliz ' + ((self.numeroPeriodo > 1) ? self.numeroPeriodo + '° años juntos!' : 'Primer año juntos!')
      self.popupAlert.message = 'Hoy queremos celebrar tu compromiso con los que más amas, sigue asegurando la tranquilidad de tu familia.'
      self.popupAlert.messageButton = 'Ver historial'
      this.flagHoy = true
      localStorage.setItem('anniversaryPolicyZS' + self.poliza.numeroPoliza, true)
    }

    // OBTENIENDO BENEFICIARIOS
    this.getBenefits({ numeroPoliza: self.poliza.numeroPoliza })
      .then(res => {
        const callback = dato => {
          if (dato.tipoBeneficiario === 'CONTINGENTE') {
            self.beneficiariosContingentes.push(dato)
          } else {
            self.beneficiariosPrincipales.push(dato)
          }
        }
        res.data.map(callback)
        if (res.data.length === 0) {
          (self.poliza.beneficiarios || []).map(callback)
        }
      })

    // OBTENIENDO COMPROBANTES
    // TMP: Fechas para comprobante electronico
    let auxDate = new Date()
    auxDate.setMonth(auxDate.getMonth() - 12)
    self.ce.startDate = moment(auxDate, 'DD-MM-YYYY').format('YYYY-MM')
    self.ce.endDate = moment(new Date(), 'DD-MM-YYYY').format('YYYY-MM')

    const datosEventLog = {
      producto: self.poliza.nombreProducto,
      grupoProducto: self.poliza.ramo.toUpperCase(),
      numeroPoliza: self.poliza.numeroPoliza
    }
    if (this.poliza.oriProducto !== 'VIDA_CASH_PLUS') {
      self.getComprobantes({ numeroPoliza: Number(self.poliza.numeroPoliza) })
        .then(res => {
          if ((res.data.codigoRespuesta === '01') && (res.data.documentos.length > 0)) {
            datosEventLog.documentos = res.data.documentos
            datosEventLog.Estado = 'Exitoso'
            self.listComrpobantesElectronicosActuales = res.data.documentos
            let documents = self.listComrpobantesElectronicosActuales
            let arrDocuments = []
            // SE OBTIENE LOS CODIGOS DE SUNAT DE CADA COMPROBANTE
            for (let index = 0; index < documents.length; index++) {
              arrDocuments.push(documents[index].tipoComprobante)
            }
            let arrDocsUniq = arrDocuments.filter(function (item, pos) {
              return arrDocuments.indexOf(item) === pos
            })
            // - this.items.push({ text: 'Tipo de comprobante', value: null })
            arrDocsUniq.forEach(el => {
              for (let j = 0; j < electronicVouchers.length; j++) {
                let noEncontroMatch = true
                // SE HACE MATCH
                if (electronicVouchers[j].codigoSunat === el) {
                  // DETECTAR SI YA ESTA REPETIDO DEL LEGACY
                  for (let x = 0; x < self.items.length; x++) {
                    if (self.items[x].text === electronicVouchers[j].descripcion) {
                      let newValue = self.items[x].value.split('.')
                      self.items[x].value = newValue[0] + '.' + electronicVouchers[j].codigoSunat + '.PESC'
                      noEncontroMatch = false
                      break
                    }
                  }
                  if (noEncontroMatch) {
                    self.items.push({ text: electronicVouchers[j].descripcion, value: electronicVouchers[j].codigoSunat + '.ESC' })
                    break
                  }
                }
              }
            })
            if (self.items.length === 1) {
              self.selectedTypeDoc = self.items[0].value
            }
          } else if ((res.data.codigoRespuesta === '01') && (res.data.documentos.length === 0)) {
            datosEventLog.error = res.data
            datosEventLog.statusCode = res.status
            datosEventLog.Estado = 'Vacío'
            this.$swal({
              title: 'Hola, ',
              text: 'En estos momentos, estamos trabajando en poner a disposición tu comprobante. Pero no te preocupes, en un plazo máximo de 5 días hábiles ya lo tendrás listo para la descarga.',
              confirmButtonText: 'Entendido'
            })
          } else {
            datosEventLog.Estado = 'Error'
            datosEventLog.error = res.data
            datosEventLog.statusCode = res.status
          }
          self.eventLog({
            categoria: 'Documentos',
            nombre: 'Consulta Comprobantes/Boletas',
            datos: datosEventLog
          })
        })
        .catch((err) => {
          datosEventLog.Estado = 'Error'
          datosEventLog.error = err.response
          self.eventLog({
            categoria: 'Documentos',
            nombre: 'Consulta Comprobantes/Boletas',
            datos: datosEventLog
          })
        })
    }

    this.loader.flag = false

    // CARGAR SOLICITUDES
    self.getAllRequirementsPerPolicy({ numeroPoliza: self.poliza.numeroPoliza })
      .then(data => {
        data.data.data.forEach(solicitud => {
          if (solicitud.transact.toLowerCase() === 'modificación de beneficiarios') {
            self.solicitudBeneficiarios.push(solicitud)
          } else if (solicitud.transact.toLowerCase() === 'cuota comodín') {
            self.solicitudComodin.push(solicitud)
          } else if (solicitud.transact.toLowerCase() === 'endoso a entidad financiera') {
            self.solicitudEndosoEntidadFinanciera.push(solicitud)
          } else if (solicitud.transact.toLowerCase() === 'liberación de endoso') {
            self.solicitudLiberacionEndoso.push(solicitud)
          } else if (solicitud.transact.toLowerCase() === 'anulación de poliza') {
            self.solicitudAnulacion.push(solicitud)
          } else if (solicitud.transact.toLowerCase() === 'seguimiento de solicitudes') {
            self.solicitudSeguimiento.push(solicitud)
          }
        })
      }).catch(() => {
        self.popupAlert.openPopup = true
        self.popupAlert.image = require('@/assets/characters/informa.svg')
        self.popupAlert.title = 'Estimado cliente'
        self.popupAlert.message = 'No hemos logrado obtener la información solicitada. Por favor, inténtalo nuevamente en unos minutos.'
        self.popupAlert.messageButton = 'Entendido'
        self.popupAlert.buttonClose = false
      })

    // this.puedeSolicitudes = (this.poliza.puedeEndosar || this.poliza.puedeCuotaComodin || this.poliza.puedeCambiarFrecuencia || this.poliza.puedeLiberarEndoso || this.poliza.puedeCambiarBeneficiario)
    this.puedeSolicitudes = (this.poliza.puedeCambiarBeneficiario)
    if (this.action) {
      this.methodView(this.action.action)
      this.actionSent = true
    }
  },
  components: {
    ButtonSelect,
    CardNumberText,
    CardIconTextDoubleRow,
    IconText,
    IconTextIcon,
    DatosMisSegurosDesktop,
    MisSolicitudes,
    HoyDesktop,
    ComprobanteElectronicoDesktop,
    DocumentosEndoso,
    MisBeneficiariosDesktop,
    MiAgenteDesktop,
    MisCanales,
    ProyeccionDesktop,
    CoberturasDesktop,
    EstadoDeCuentaDesktop,
    PopupAlertMessage,
    HoyDesktopHasta5Vue,
    BeneficiosDesbloqueados,
    MisVales
  }
}
</script>

<style scoped>
@media (min-width : 1024px) {
  .box-buttons-centered {
    justify-content: center;
  }

  .box-buttons-centered > .flex {
    flex: 0 0 auto;
  }

  .box-buttons-centered > .flex + .flex {
    margin-left: 1em;
  }

  .box-cobertura-select {
    transition: 0.5s;
    background-color: #bd0072 !important;
  }

  .box-main-mis-seguros-desktop-formatter {
    background-color: #ffffff;
    border-radius: 10px;
    min-width: 65em !important;
    margin: 5px 9px 0 5px;
    padding: 15px 0 20px;
    height: -webkit-fill-available;
  }

  .box-main-mis-seguros-desktop-formatter .box-main-menu-formatter {
    display: flex;
    align-items: center;
  }

  .box-main-mis-seguros-desktop-formatter .box-main-menu-formatter:last-child {
    margin: auto 0;
  }

  .box-main-menu-formatter .detalle-main-menu {
    border: 1px solid #d9d9d9;
    border-radius: 10px;
  }

  .box-main-menu-formatter .desbloqueados {
    border: 1px solid #d9d9d9;
    border-radius: 10px;
    overflow-y: auto;
    padding: 1em .7em;
  }

  .box-main-menu-formatter .hoy {
    padding: 1em .7em;
  }

  .box-main-menu-formatter .hoy .box-hoy-desktop-formatter {
    overflow-y: auto;
    padding: 0 .5em;
    max-height: 35.6em;
  }

  .box-menu-mis-seguros {
    max-height: 19.7em;
    box-sizing: content-box;
    width: 22.5em;
    padding-right: 1.4em;
  }

  .box-menu-mis-seguros.box-small {
    height: 13em;
  }

  .box-menu-mis-seguros .box-menu-formatter {
    padding: 0.1em 0.5em 0em 1em;
    border: 1px solid #C4C4C4;
    border-radius: 10px;
    margin-bottom: 5px;
    cursor: pointer;
  }

  .box-menu-mis-seguros .box-menu-formatter:last-child {
    margin-bottom: 1px;
  }

  .box-menu-mis-seguros>.box-menu-formatter:hover {
    background-color: #f9f9f9;
  }
}

@media (min-width : 1400px),
(min-height: 900px) {
  .box-main-mis-seguros-desktop-formatter {
    width: 68em;
    margin: 5px auto 0;
  }

  .box-main-mis-seguros-desktop-formatter .box-main-menu-formatter {
    align-items: flex-start;
  }

  .box-main-mis-seguros-desktop-formatter .box-main-menu-formatter:last-child {
    margin-top: 5em;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/mis-seguros/MisSegurosDesktop.vue